import {utils} from '@wallaby-ui/core';
import {isEmpty, map} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {useIntl} from 'react-intl';

import stylesAutoLayout from './AutoLayout.less';
import DataChangesItem from './DataChangesItem';
import {ContentComponent} from 'src/js/model/auto_layout_content_schema';
import {LayoutComponent} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const DataChanges = ({content, dataChanges, layout, metadata, title}) => {
  const intl = useIntl();
  const changesTitle = title
    ? utils.TranslateUtils.translate(title, intl)
    : null;

  return isEmpty(dataChanges) ? null : (
    <div className={stylesAutoLayout.dlScreenComponentContainerVertical}>
      {changesTitle ? (
        <div className={stylesAutoLayout.dlComponentLabel} title={changesTitle}>
          {changesTitle}
        </div>
      ) : null}
      {map(dataChanges, (item, pathToData) => {
        const contentPropertyInfo = content.getPropertyByPathToData(
          pathToData,
          metadata.getContent()
        );
        return (
          <DataChangesItem
            key={pathToData}
            content={contentPropertyInfo.property}
            data={item}
            isArray={contentPropertyInfo.isArray}
            layout={layout.getPropertyByPathToData(
              pathToData,
              metadata.getLayout()
            )}
            pathToData={pathToData}
          />
        );
      })}
    </div>
  );
  /* eslint-enable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
};

DataChanges.propTypes = {
  content: PropTypes.instanceOf(ContentComponent).isRequired,
  dataChanges: PropTypes.objectOf(PropTypes.any),
  layout: PropTypes.instanceOf(LayoutComponent).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  title: PropTypes.string,
};

DataChanges.defaultProps = {
  dataChanges: null,
  title: null,
};

export default DataChanges;
